import { render } from "./PreparingNewSemesterView.vue?vue&type=template&id=4239cbd3"
import script from "./PreparingNewSemesterView.vue?vue&type=script&lang=js"
export * from "./PreparingNewSemesterView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__